// Promo related constants
import { ROUTE } from 'src/common/constants';
import { PromoType as PROMO_TYPE } from '@ccmn/rhino';
import { ACTIVE_VARIATION } from 'src/components/lucky-chats/variations';

type PromoConfig = {
    [key in PROMO_TYPE]: {
        title: string;
        route: string;
        layoutClass: string;
    };
};

const PROMO: PromoConfig = {} as PromoConfig;

PROMO[PROMO_TYPE.PUZZLE] = {
    title: `Valentines's Day 2025`,
    route: ROUTE.VALENTINES,
    layoutClass: 'valentines',
};

PROMO[PROMO_TYPE.GUESSBOX] = {
    title: `24th Celebration`,
    route: ROUTE.ANNIVERSARY,
    layoutClass: 'anniversary',
};

PROMO[PROMO_TYPE.SPOTPRIZES] = {
    title: '',
    route: ROUTE.LUCKY_CHATS,
    layoutClass: ACTIVE_VARIATION,
};

export { PROMO_TYPE, PROMO };
